import React from "react";
// Import the useDropzone hooks from react-dropzone
import { useDropzone } from "react-dropzone";

const Dropzone = ({ onDrop, accept }: any) => {
    // Initializing useDropzone hooks with options
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept
    });

    /* 
      useDropzone hooks exposes two functions called getRootProps and getInputProps
      and also exposes isDragActive boolean
    */

    return (
        <div style={{ borderStyle: 'dotted', borderColor: isDragActive ? 'yellowgreen' : 'crimson', cursor:'pointer' }} className="dropzone-div" {...getRootProps()}>
            <input className="dropzone-input" {...getInputProps()} />
            <div>
                {isDragActive ? (
                    <p className="dropzone-content">Suelta aquí para actualizar el árbol causal (solo archivos xlsx)</p>
                ) : (
                    <p className="dropzone-content">
                        Arrástra un archivo aquí para actualizar, o haz click
                    </p>
                )}
            </div>
        </div>
    );
};

export default Dropzone;